export default __webpack_public_path__ + "static/media/search-meg.1b183d83.png";